<div class="card-container h-100"
  style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold"
    style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-headset mr-1"></i> Tele-Verification (TVR) Records
  </div>

  <div class="p-3" *ngIf="!TVRQuestionData || TVRQuestionData.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No TVR Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="TVRQuestionData && TVRQuestionData.length > 0">
    <!-- TVR Meta summary box -->
    <div class="p-2 mb-3 rounded border bg-light" style="font-size: 0.75rem;" *ngIf="TVRQuestionData[0]">
      <div class="d-flex justify-content-between mb-1">
        <span><strong>Done By:</strong> {{ TVRQuestionData[0].TVR_Done_By || '-' }}</span>
        <span><strong>Done On:</strong> {{ TVRQuestionData[0].TVR_DoneOn || '-' }}</span>
      </div>
      <div *ngIf="TVRQuestionData[0].TVR_Remark" class="text-muted">
        <strong>Remark:</strong> {{ TVRQuestionData[0].TVR_Remark }}
      </div>
    </div>

    <!-- Q&A List -->
    <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div *ngFor="let item of TVRQuestionData">
        <div class="p-2.5 rounded border" style="background: #fafbfc; border-color: #e2e8f0 !important;">
          <div class="font-weight-bold text-dark mb-1" style="font-size: 0.8125rem;">
            Q: {{ item.TVR_Question }}
          </div>
          <div class="text-muted small mb-1" *ngIf="item.TVR_Question_Hindi">
            {{ item.TVR_Question_Hindi }}
          </div>
          <div class="d-flex align-items-start mt-1">
            <span class="badge badge-info mr-2 mt-1">Ans</span>
            <span class="font-weight-bold text-primary" style="font-size: 0.8125rem; white-space: pre-wrap; word-break: break-word; flex: 1;">
              {{ item.TVR_QuestionAnswer || 'N/A' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>